<div class="header" (click)="expanded = !expanded">
  <div class="label-tiny">
    <span class="icon">
      <ng-content select="[icon]"></ng-content>
    </span>
    <ng-content select="[title]"></ng-content>
  </div>
  <div class="info">
    <ng-content select="[info]"></ng-content>
  </div>
  <div class="expand-line"></div>
  <span>
    <mat-icon>{{ expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
  </span>
</div>
@if (expanded) {
  <div class="content">
    <ng-template [ngTemplateOutlet]="template"></ng-template>
  </div>
}